import React from 'react'
import { TifLayer } from './TifLayer'

export function TifsLayers({
    activeIndex,
    urls,
    escalas,
    opacity,
    escalasContinuas,
    onReady,
}) {
    return urls.map((url, i) => {
        return (
            activeIndex === i && (
                <TifLayer
                    key={i}
                    escala={
                        escalasContinuas.length > 0
                            ? escalasContinuas[i]
                            : escalas
                    }
                    url={url}
                    opacity={opacity}
                    escalaContinua={escalasContinuas.length > 0}
                    active={activeIndex === i}
                    onReady={onReady}
                />
            )
        )
    })
}
